import { AZURE_STORAGE_ACCOUNT, AZURE_STORAGE_ACCESS_KEY, TableName, TableNameOT } from "./../Config.jsx"
import { CloudStatus, CloudStatusIconColor } from '../Enums/ClodStatusEnum';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import Info from '@material-ui/icons/Info';
import React from 'react';
import ReactDOMServer from 'react-dom/server';

var azure = require('azure-storage');

export default class CloudStatusService {
    tableService;
    data;
    constructor(data) {
        this.data = data;
        var tableUri = 'https://' + AZURE_STORAGE_ACCOUNT + '.table.core.windows.net';
        this.tableService = this.getTableService(tableUri);
        //this.tableService = azure.createTableServiceWithSas(tableUri, AZURE_STORAGE_ACCESS_KEY);
        this.data.Service.AOStatus = this.createAOStatus.bind(this);
    }


    getTableService(tableUri) {
        try {
            return azure.createTableServiceWithSas(tableUri, AZURE_STORAGE_ACCESS_KEY);
        }
        catch (error) {
            console.log(error);
            return null;
        }

    }

    getAOStatus() {
        return new Promise((resolve, reject) => {
            var query = new azure.TableQuery().top(1);
            var options = { payloadFormat: "application/json" };
            this.tableService.queryEntities(TableName, query, null, options, function (error, result, response) {
                if (!error) {
                    // result.entries contains entities matching the query
                    console.log(result.entries);
                    resolve(result.entries);
                } else {
                    console.log(error);
                    reject(error);
                }
            });
        });
    }

    createAOStatus(statusData) {

        var maxDate = new Date("9999-12-31");
        var rowKeyValue = (maxDate.getTime() - (new Date()).getTime()).toString();

        var responseObj = this.getCloudStatusObject(statusData.statusType);

        var entGen = azure.TableUtilities.entityGenerator;
        var entity = {};
        if (statusData.statusType === CloudStatus.Custom) {

            entity = {
                PartitionKey: entGen.String('00000000-0000-0000-0000-000000000000'),
                RowKey: entGen.String(rowKeyValue),
                IssueType: entGen.Int32(statusData.statusType),
                Reason: entGen.String(statusData.reason),
                Header: entGen.String(statusData.header),
                DisplayText: entGen.String(statusData.description),
                CreatedDate: entGen.DateTime(new Date()),                
                isPersisted: entGen.Boolean(false),
                IconColor: entGen.String(statusData.icon)
            };
        }
        else {
            entity = {
                PartitionKey: entGen.String('00000000-0000-0000-0000-000000000000'),
                RowKey: entGen.String(rowKeyValue),
                IssueType: entGen.Int32(statusData.statusType),
                Reason: entGen.String(statusData.reason),
                Header: entGen.String(ReactDOMServer.renderToStaticMarkup(responseObj.header)),
                DisplayText: entGen.String(ReactDOMServer.renderToStaticMarkup(responseObj.description)),
                ImageUrl: entGen.String(ReactDOMServer.renderToStaticMarkup(responseObj.image)),
                CreatedDate: entGen.DateTime(new Date()),                
                isPersisted: entGen.Boolean(false),
                IconColor: entGen.String(responseObj.color)
            };
        }
        return new Promise((resolve, reject) => {
            this.tableService.insertEntity(TableName, entity, (error, result, response) => {
                if (!error) {
                    console.log(result);
                    this.data.Service.SuccessCallback("Entry created successfully.");
                    resolve(result);
                    // result contains the ETag for the new entity
                } else {
                    console.log(error);
                    this.data.Service.ErrorCallback(error.message);
                    reject(error);
                }
            });
        });
    }

    //For AO
    getCloudStatusObject(statusValue) {
        switch (statusValue) {
            case CloudStatus.NoIssue:
                return {
                    image: <CheckCircle fontSize="large" className="icon md-green" />,
                    header: <span>Amicus Cloud is fully operational at this time.</span>,
                    description: <span>If you are encountering a problem, there may be something specific to your account. Please contact the support team at 800-472-2289 or via email at <a href="mailto:cloudsupport@abacusnext.com">cloudsupport@abacusnext.com</a></span>,
                    color: CloudStatusIconColor.Green
                }
            case CloudStatus.FirstReportOfIssue:
                return {
                    image: <Error fontSize="large" className="icon md-red"></Error>,
                    header: <span>Please note that we are currently investigating reports of some issues accessing Amicus Cloud. <br /> <br />
                        We will post an update here as soon as we have more information. Please stand by. <br /><br />
                        We apologize for any inconvenience this issue may cause. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:cloudsupport@abacusnext.com"> cloudsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Red
                }
            case CloudStatus.UnknownIssue:
                return {
                    image: <Error fontSize="large" className="icon md-red"></Error>,
                    header: <span>Please note that some users are unable to access Amicus Cloud at this time. <br /><br />
                        We are currently working to resolve the issue and we will post an update here as soon as possible. <br /> <br />
                        We apologize for any inconvenience this issue may cause. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:cloudsupport@abacusnext.com"> cloudsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Red
                }
            case CloudStatus.DnsError:
                return {
                    image: <RemoveCircle fontSize="large" className="icon md-orange"></RemoveCircle>,
                    header: <span> As a result of a worldwide DNS issue, some users may not be able to access Amicus Cloud using the normal login page. <br /><br />
                        During this outage please use this alternate link instead: <a href="amicus.cloudapp.net">amicus.cloudapp.net</a> <br /><br />
                        We apologize for any inconvenience this issue may cause. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:cloudsupport@abacusnext.com"> cloudsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Orange
                }
            case CloudStatus.IntermediaIssue:
                return {
                    image: <RemoveCircle fontSize="large" className="icon md-orange"></RemoveCircle>,
                    header: <span> Please note that some Amicus Hosted Exchange users are experiencing problems accessing Amicus Cloud.<br /><br />
                        We are currently working with our hosted exchange partner to resolve the issue. Please stand by for updates. <br /><br />
                        If you have your own Exchange provider you should not have any problems accessing Amicus Cloud at this time. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:cloudsupport@abacusnext.com"> cloudsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Orange
                }
            case CloudStatus.OperationalButNotFully:
                return {
                    image: <RemoveCircle fontSize="large" className="icon md-orange"></RemoveCircle>,
                    header: <span>
                        Amicus Cloud is currently experiencing performance issues that may impact the speed of the program. <br /><br />
                        We are working to resolve the issue which may result in some actions taking longer than normal within the program. <br /><br />
                        Please check back here for updates.
                    </span>,
                    description: <span>If you are encountering a problem, there may be something specific to your account. Please contact the support team at 800-472-2289 or via email at <a href="mailto:cloudsupport@abacusnext.com">cloudsupport@abacusnext.com</a></span>,
                    color: CloudStatusIconColor.Orange
                }
            case CloudStatus.IterationUpdate:
                return {
                    image: <Info fontSize="large" className="icon md-blue"></Info>,
                    header: <span>Amicus Cloud was updated as a part of regularly scheduled maintenance. <br /><br />
                        See <a href="What's New">What's New</a> for all the details. <br /><br />
                    </span>,
                    description: <span>If you are encountering a problem, there may be something specific to your account. Please contact the support team at 800-472-2289 or via email at <a href="mailto:cloudsupport@abacusnext.com">cloudsupport@abacusnext.com</a></span>,
                    color: CloudStatusIconColor.Blue
                }
            case CloudStatus.SilentUpdate:
                return {
                    image: <Info fontSize="large" className="icon md-blue"></Info>,
                    header: <span>Performance improvements were applied to Amicus Cloud as a part of regularly scheduled maintenance <br /><br /></span>,
                    description: <span>If you are encountering a problem, there may be something specific to your account. Please contact the support team at 800-472-2289 or via email at <a href="mailto:cloudsupport@abacusnext.com">cloudsupport@abacusnext.com</a></span>,
                    color: CloudStatusIconColor.Blue
                }
            default:
                return null;
        }
    }

    //For OT
    getCloudStatusObjectOT(statusValue) {
        switch (statusValue) {
            case CloudStatus.NoIssue:
                return {
                    image: <CheckCircle fontSize="large" className="icon md-green" />,
                    header: <span>OfficeTools Cloud is fully operational at this time.</span>,
                    description: <span>If you are encountering a problem, there may be something specific to your account.  Please contact the support team at 800-726-3339 or via email at <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a></span>,
                    color: CloudStatusIconColor.Green
                }
            case CloudStatus.FirstReportOfIssue:
                return {
                    image: <Error fontSize="large" className="icon md-red"></Error>,
                    header: <span>Please note that we are currently investigating reports of some issues accessing OfficeTools Cloud. <br /> <br />
                        We will post an update here as soon as we have more information. Please stand by. <br /><br />
                        We apologize for any inconvenience this issue may cause. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Red
                }
            case CloudStatus.UnknownIssue:
                return {
                    image: <Error fontSize="large" className="icon md-red"></Error>,
                    header: <span>Please note that some users are unable to access OfficeTools Cloud at this time. <br /><br />
                        We are currently working to resolve the issue and we will post an update here as soon as possible. <br /> <br />
                        We apologize for any inconvenience this issue may cause. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Red
                }
            case CloudStatus.DnsError:
                return {
                    image: <RemoveCircle fontSize="large" className="icon md-orange"></RemoveCircle>,
                    header: <span> As a result of a worldwide DNS issue, some users may not be able to access OfficeTools Cloud using the normal login page. <br /><br />
                        During this outage please use this alternate link instead: <a href="officetoolsweb.cloudapp.net">officetoolsweb.cloudapp.net</a> <br />
                        We apologize for any inconvenience this issue may cause. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Orange
                }
            case CloudStatus.IntermediaIssue:
                return {
                    image: <RemoveCircle fontSize="large" className="icon md-orange"></RemoveCircle>,
                    header: <span> Please note that some OfficeTools Hosted Exchange users are experiencing problems accessing OfficeTools Cloud.<br /><br />
                        We are currently working with our hosted exchange partner to resolve the issue. Please stand by for updates. <br /><br />
                        If you have your own Exchange provider you should not have any problems accessing OfficeTools Cloud at this time. </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Orange
                }
            case CloudStatus.OperationalButNotFully:
                return {
                    image: <RemoveCircle fontSize="large" className="icon md-orange"></RemoveCircle>,
                    header: <span>
                        OfficeTools Cloud is currently experiencing performance issues that may impact the speed of the program. <br /><br />
                        We are working to resolve the issue which may result in some actions taking longer than normal within the program. <br /><br />
                        Please check back here for updates.
                    </span>,
                    description: <span> If you would like to be notified when the issue has been resolved please send an email to <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a> to open a ticket.</span>,
                    color: CloudStatusIconColor.Orange
                }
            case CloudStatus.IterationUpdate:
                return {
                    image: <Info fontSize="large" className="icon md-blue"></Info>,
                    header: <span>OfficeTools Cloud was updated as a part of regularly scheduled maintenance. <br /><br />                      
                    </span>,
                    description: <span>If you are encountering a problem, please contact the support team at 800-726-3339 or via email at <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a></span>,
                    color: CloudStatusIconColor.Blue
                }
            case CloudStatus.SilentUpdate:
                return {
                    image: <Info fontSize="large" className="icon md-blue"></Info>,
                    header: <span>Performance improvements were applied to OfficeTools Cloud as a part of regularly scheduled maintenance <br /><br /></span>,
                    description: <span>If you are encountering a problem, please contact the support team at 800-726-3339 or via email at <a href="mailto:otcsupport@abacusnext.com">otcsupport@abacusnext.com</a></span>,
                    color: CloudStatusIconColor.Blue
                }
            default:
                return null;
        }
    }

    createOTStatus(statusData) {

        var maxDate = new Date("9999-12-31");
        var rowKeyValue = (maxDate.getTime() - (new Date()).getTime()).toString();

        var responseObj = this.getCloudStatusObjectOT(statusData.statusType);

        var entGen = azure.TableUtilities.entityGenerator;
        var entity = {};
        if (statusData.statusType === CloudStatus.Custom) {

            entity = {
                PartitionKey: entGen.String('00000000-0000-0000-0000-000000000000'),
                RowKey: entGen.String(rowKeyValue),
                IssueType: entGen.Int32(statusData.statusType),
                Reason: entGen.String(statusData.reason),
                Header: entGen.String(statusData.header),
                DisplayText: entGen.String(statusData.description),
                CreatedDate: entGen.DateTime(new Date()),                
                isPersisted: entGen.Boolean(false),
                IconColor: entGen.String(statusData.icon)
            };
        }
        else {
            entity = {
                PartitionKey: entGen.String('00000000-0000-0000-0000-000000000000'),
                RowKey: entGen.String(rowKeyValue),
                IssueType: entGen.Int32(statusData.statusType),
                Reason: entGen.String(statusData.reason),
                Header: entGen.String(ReactDOMServer.renderToStaticMarkup(responseObj.header)),
                DisplayText: entGen.String(ReactDOMServer.renderToStaticMarkup(responseObj.description)),
                ImageUrl: entGen.String(ReactDOMServer.renderToStaticMarkup(responseObj.image)),
                CreatedDate: entGen.DateTime(new Date()),                
                isPersisted: entGen.Boolean(false),
                IconColor: entGen.String(responseObj.color)
            };
        }
        return new Promise((resolve, reject) => {
            this.tableService.insertEntity(TableNameOT, entity, (error, result, response) => {
                if (!error) {
                    console.log(result);
                    this.data.Service.SuccessCallback("Entry created successfully.");
                    resolve(result);
                    // result contains the ETag for the new entity
                } else {
                    console.log(error);
                    this.data.Service.ErrorCallback(error.message);
                    reject(error);
                }
            });
        });
    }
   getOTStatus() {
        return new Promise((resolve, reject) => {
            var query = new azure.TableQuery().top(1);
            var options = { payloadFormat: "application/json" };
            this.tableService.queryEntities(TableNameOT, query, null, options, function (error, result, response) {
                if (!error) {
                    // result.entries contains entities matching the query
                    console.log(result.entries);
                    resolve(result.entries);
                } else {
                    console.log(error);
                    reject(error);
                }
            });
        });
    }
}
